export const actionTypePrefix = '@@POLLS';
